<script lang="ts">
	//Formatters
	import { format } from '../../services/i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../types/Device';

	import { capFirstChar } from '../../helpers/utilities';
	import { navigateToSetting } from 'src/stores/ui/navigate-to'; //proper function with device drawer update

	export let device: Device;
	export let values: { minVersion: string; fwVersion: string };
</script>

<Alert
	type="warning"
	heading={$format('alert_heading_device_fw_update_encouraged', {
		default: 'Firmware update is encouraged',
	})}
	message={$format('alert_message_device_fw_update_encouraged', {
		values,
		default:
			'We recommend updating your firmware to the latest version to ensure you have the best experience.',
	})}
	cta={{
		title: capFirstChar(
			$format('sub_settings_title_update_firmware', {
				default: 'Upgrade firmware',
			}),
		),
	}}
	on:cta_click={() => navigateToSetting(device.id, 'settings', 'firmware_version')}
/>
